import { Http } from "../model/Http";
class saasOrder extends Http{
  // 电影票订单
  getMovieOrder(data){
    let url = 'saas-backstage/movie-order/search'
    return this.postAjaxBySaas(url,{
      ...data
    })
  }
  // 用户订单
  getUserOrder(data){
    let url = 'saas-movie/open-fans/search'
    return this.postAjaxBySaas(url,{
      ...data
    })
  }
  // 获取平台列表
  platformList(data){
    let url = 'saas-movie/open-app/app-list'
    return this.postAjaxBySaas(url,{
      ...data
    })
  }
  // 套餐订单
  getSetTheOrder(data){
    const url = 'saas-backstage/consum-records/search'
    return this.postAjaxBySaas(url,{
      ...data
    })
  }
  // 订单详情
  orderDetail(data){
    const url = 'saas-backstage/movie-order/order-detail'
    return this.postAjaxBySaas(url,{
      ...data
    })
  }
  // 关闭订单
  closeOrder(data){
    const url = 'saas-backstage/movie-order/close-order'
    return this.postAjaxBySaas(url,{
      ...data
    })
  }
  // 获取指派规则列表
  getAssignRules(data){
    const url = 'saas-backstage/appoint-rule/search'
    return this.postAjaxBySaas(url,{
      ...data
    })
  }
  // 新增规则
  addRules(data){
    const url = 'saas-backstage/appoint-rule/add'
    return this.postAjaxBySaas(url,{
      ...data
    })
  }
  // 删除指派规则
  deleteAssignRules(data){
    const url = 'saas-backstage/appoint-rule/del'
    return this.postAjaxBySaas(url,{
      ...data
    })
  }
  // 修改规则
  updateRules(data){
    const url = 'saas-backstage/appoint-rule/update'
    return this.postAjaxBySaas(url,{
      ...data
    })
  }
  updateStatus(data){
    const url = 'saas-backstage/appoint-rule/update-rule-status'
    return this.postAjaxBySaas(url,{
      ...data
    })
  }
  // 转快出
  fastOrder(data){
    const url = 'saas-backstage/movie-order/turn-out-quickly'
    return this.postAjaxBySaas(url,{
      ...data
    })
  }
  // 影票定价列表
  moviePriceList(data){
    const url = 'saas-backstage/cinema-discount/search'
    return this.postAjaxBySaas(url,{
      ...data
    })
  }
  // 单独修改折扣
  updateDiscount(data){
    const url = 'saas-backstage/cinema-discount/update'
    return this.postAjaxBySaas(url,{
      ...data
    })
  }
  // 批量修改折扣
  updateDiscountBatch(data){
    const url = 'saas-backstage/cinema-discount/batch-update'
    return this.postAjaxBySaasTicket(url,{
      ...data
    })
  }
  // 资金明细
  financialDetails(data){
    const url = 'saas-backstage/user-balance/search'
    return this.postAjaxBySaas(url,{
      ...data
    })
  }
  // 获取城市列表
  getCity(data){
    const url = 'saas-backstage/cinema-discount/city-page'
    return this.postAjaxBySaas(url,{
      ...data
    })
  }
  // 设置指派规则
  settingRule(data){
    const url = 'saas-backstage/appoint-rule/setting-appoint-rule'
    return this.postAjaxBySaasTicket(url,{
      ...data
    })
  }
  // 绑定票务号
  bindingTicket(data){
    const url = 'saas-backstage/ticket-author/ticket-qr-code'
    return this.postAjaxBySaasTicket(url,{
      ...data
    })
  }
  // 获取省份
  getProvince(data){
    const url = 'saas-backstage/cinema-discount/province-list\n'
    return this.postAjaxBySaasTicket(url,{
      ...data
    })
  }
  // 影片导出
  exportMovieOrder(data){
    const url = 'saas-backstage/movie-order/export'
    return this.postAjaxBySaasExport(url,{
      ...data
    })
  }
  // 用户信息导出
  exportUserList(data){
    const url = 'saas-movie/open-fans/export'
    return this.postAjaxBySaasExport(url,{
      ...data
    })
  }
  // 套餐订单导出
  exportSetTheOrder(data){
    const url = 'saas-backstage/consum-records/export'
    return this.postAjaxBySaasExport(url,{
      ...data
    })
  }
  // 套餐订单导出
  exportDetail(data){
    const url = 'saas-backstage/user-balance/export'
    return this.postAjaxBySaasExport(url,{
      ...data
    })
  }
  // 获取配置
  getConfig(data){
    const url = 'saas-backstage/home-page/init-config'
    return this.postAjaxBySaas(url,{
      ...data
    })
  }
}
export {
  saasOrder
}



// WEBPACK FOOTER //
// ./src/javaApi/saasOrder.js